import { useEffect, useState } from 'react';

import { ObservableAndState } from '../utils/observable_and_state';

export const useObservableAndState = <T>(observableAndState: ObservableAndState<T>) => {
  const { state, observable } = observableAndState;
  const [data, setData] = useState<T>(state);

  useEffect(() => {
    const subscription = observable.subscribe((value) => setData(value));
    return () => subscription.unsubscribe();
  }, [observable]);

  return data;
};
